import { currencySlice } from './slice'

// Company Details
export const { setCurrencyListLoading } = currencySlice.actions
export const { setCurrencyListData } = currencySlice.actions
export const { resetCurrencyListState } = currencySlice.actions
